import type { NextPage } from 'next'
import styles from 'styles/Break.module.scss'
import { Size } from 'types/size'
interface Props {
  size?: Size
}
const Break: NextPage<Props> = (props: Props) => {
  let className = styles.medium //DEFAULT
  if (props.size === Size.xxSmall) className = styles.xxSmall
  if (props.size === Size.xSmall) className = styles.xSmall
  else if (props.size === Size.small) className = styles.small
  else if (props.size === Size.large) className = styles.large
  else if (props.size === Size.xLarge) className = styles.xLarge
  else if (props.size === Size.xxLarge) className = styles.xxLarge
  return <div className={className}></div>
}

export default Break
